import MeetingRegistery from './MeetingRegistery.container';

export default MeetingRegistery;